import { createContext, useContext, useEffect, useState } from 'react';

const RelativeTimeDateContext = createContext(new Date());

export function RelativeTimeDateProvider({ children }) {
  const [currentDate, setCurrentDate] = useState(() => new Date());

  useEffect(() => {
    const intervalId = setInterval(() => setCurrentDate(new Date()), 3000);

    return () => clearInterval(intervalId);
  }, []);

  return <RelativeTimeDateContext.Provider value={currentDate}>{children}</RelativeTimeDateContext.Provider>;
}

export function useRelativeTimeDate() {
  return useContext(RelativeTimeDateContext);
}
